/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsMultisiteDiscountsCtrl
 * @description A report of discounts for all companies
 */
angular.module('mercury.modules.reports.multisite')
.controller('ReportsMultisiteDiscountsCtrl', ["comparetime", "$filter", "multisite", "ReportSales", "$q", "reporttime", "$scope", "title", "userinfo", function(comparetime, $filter, multisite, ReportSales, $q, reporttime, $scope, title, userinfo) {
  title.set('Discounts');
  multisite.setMultisite(true);

  $scope.results = [];
  $scope.compare = comparetime.time() !== null;
  $scope.graphOptions = {
    vAxis: {format: 'decimal'},
    animation: null
  };
  $scope.graphColumns = [
    {label: 'Site', type: 'string', key: 'name'},
    {label: '% Of Sales', type: 'number', key: 'percent', filter: 'currency'}
  ];

  var salesResults = {};
  var compareResults = {};

  var createResultLine = function(company) {
    // we don't want to add companies to the resultset multiple times, so check the restuls array and only add if it's a new companyId
    var newCompany = true;
    angular.forEach($scope.results, function(result) {
      if (result.companyId == company.id) {
        newCompany = false;
        result.show = '1';
      }
    });

    if (newCompany) {
      $scope.results.push({
        companyId: company.id,
        show: '1',
        name: company.name,
        sales: null,
        salesCompare: null,
        discounts: null,
        discountsCompare: null,
        percent: null,
        percentCompare: null
      });
    }
  };

  var buildReport = function() {
    angular.forEach(userinfo.companies(), function(company) {
      if (multisite.isCompanyDisabled(company.id)) {
        angular.forEach($scope.results, function(result) {
          if (result.companyId == company.id) {
            result.show = '0';
          }
        });
        $scope.$emit('dataTableUpdate');
        return;
      }

      // fetch data for any sites that were deselected when we first fetched the results
      if (!salesResults[company.id]) {
        salesResults[company.id] = ReportSales.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval(), company.id);
      }
      if ($scope.compare && !compareResults[company.id]) {
        compareResults[company.id] = ReportSales.getByInterval(comparetime.start(), comparetime.end(), reporttime.interval(), company.id);
      }

      salesResults[company.id].then(function(salesRequestResult) {
        var sales = $filter('sumof')(salesRequestResult, 'invoices');
        var discounts = $filter('sumof')(salesRequestResult, 'discounts');

        angular.forEach($scope.results, function(resultLine) {
          if (resultLine.companyId == company.id) {
            resultLine.sales = sales;
            resultLine.discounts = discounts;
            resultLine.percent = sales !== 0 ? (discounts / sales) * 100 : 0;
          }
        });

        $scope.$emit('update.googleChart');
      });

      if (compareResults[company.id]) {
        compareResults[company.id].then(function(compareResult) {
          var salesCompare = $filter('sumof')(compareResult, 'invoices');
          var discountsCompare = $filter('sumof')(compareResult, 'discounts');

          angular.forEach($scope.results, function(resultLine) {
            if (resultLine.companyId == company.id) {
              resultLine.salesCompare = salesCompare;
              resultLine.discountsCompare = discountsCompare;
              resultLine.percentCompare = salesCompare !== 0 ? (discountsCompare / salesCompare) * 100 : 0;
            }
          });

          $scope.$emit('update.googleChart');
        });
      }

      createResultLine(company);
    });
    $scope.$emit('dataTableUpdate');
  };

  // initialize the results and send off the requests
  angular.forEach(userinfo.companies(), function(company) {
    if (multisite.isCompanyDisabled(company.id)) {
      angular.forEach($scope.results, function(result) {
        if (result.companyId == company.id) {
          result.show = '0';
        }
      });
      return;
    }

    createResultLine(company);

    salesResults[company.id] = ReportSales.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval(), company.id);
    if ($scope.compare) {
      compareResults[company.id] = ReportSales.getByInterval(comparetime.start(), comparetime.end(), reporttime.interval(), company.id);
    }
  });

  $scope.loading = $q.race(salesResults);
  $scope.loading.then(buildReport);
  $scope.$on('userInfoUpdated', buildReport);
}]);
